// Routes owned by the Holiday module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const holidayPaths = {
    workdayHoliday: '/workdays/holiday',
    // Unreferenced: no paths.* caller; route is live (/workdays/holiday/:id).
    workdayHolidayDetail: '/workdays/holiday/:id',
    workdayHolidayCreate: '/workdays/holiday/new',
} as const
